import React from 'react'
import Header from "components/Headers/Header.js";
import { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Alert, CardFooter, Button, FormGroup, Form, Input, InputGroup, Table} from "reactstrap";
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { format } from 'date-fns'; 
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

function Support() {

    const [loadingsubmit, setLoadingsubmit] = useState(true)
    const [error, setError]=useState(false)
    const [message, setMessage]=useState(true)

    const [title, setTitle] = useState('')
    const [text, setText] = useState('')

    const [modal, setModal] = useState(false);  

    const toggleModal = () => setModal(!modal);

    const token = useSelector((state) => state.userLogin.userInfo.token);

    const [loading, setLoading]=useState(true)
    const [ticketopen, setTicketopen] = useState([])

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/support/ticket-list/`, config);
                
                setTicketopen(response.data)

            } catch (error) {

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);


    const handleSubmit = async(e) => {
        
        setLoadingsubmit(false)

        if (title==='') {
            setMessage(t('The title is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (text==='') {
            setMessage(t('The text is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        try {

            const config = {
                headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
                }
            };  

            const payload = {
                "title": title,
                "text": text
            } 
                
            await axios.post(`${process.env.REACT_APP_BACKEND_API}/support/create-ticket/`, payload, config);

        } catch (error) {
            setMessage(t("Some problems occured, please retry and if the problem persists please send an email to info@automaticfarmsolution.com"))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true)
            return;
        } finally {
            setLoadingsubmit(true)
            toggleModal()

            const config = {
                headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
                }
            };  
            
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/support/ticket-list/`, config);
        
            setTicketopen(response.data)
        }

    }

    return (
        <div>
        <Header/>
        <Container className="mt--15" fluid>
            <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                    <Card>
                        <CardHeader>
                            <h3>{t('Ticket Open')}</h3>
                        </CardHeader>
                        <CardBody>
                            {loading ? (
                                <Spinner>
                                    {t('Loading')}
                                </Spinner>
                            ):(
                                <>                                   
                                    <Table className="align-items-center table-flush text-center" responsive>
                                        <thead className="thead-light">
                                            <tr>
                                            <th scope="col">{t('ID Ticket')}</th>
                                            <th scope="col">{t('Date')}</th>
                                            <th scope="col">{t('Title')}</th>
                                            <th scope="col">{t('Text')}</th>
                                            <th scope="col">{t('Is completed')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ticketopen.map((farmer, index) => (
                                                <tr key={index}>
                                                    <td>{farmer.id}</td>
                                                    <td>{format(new Date(farmer.created_at), 'PPpp')}</td>
                                                    <td>{farmer.title}</td>
                                                    <td>{farmer.text}</td>
                                                    <td>
                                                    {farmer.completed ? (
                                                        <FaCheckCircle color="green" />
                                                    ) : (
                                                        <FaTimesCircle color="red" />
                                                    )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>  
                                </>
                            )}
                        </CardBody>
                    </Card>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                    <Card>
                        <CardHeader>
                            <h3>{t('Add New Ticket Support')}</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form">
                                {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                                <FormGroup>
                                    <InputGroup className="input-group-alternative mb-3">
                                        <Input 
                                            placeholder={t("Ticket Title")}
                                            type="text"
                                            controlid='device'
                                            value={title} 
                                            onChange={(e) => setTitle(e.target.value)} />
                                    </InputGroup>
                                    <InputGroup className="input-group-alternative mb-3">
                                        <Input 
                                            placeholder={t("Ticket Text")}
                                            type="text"
                                            controlid='device'
                                            value={text} 
                                            onChange={(e) => setText(e.target.value)} />
                                    </InputGroup>
                                </FormGroup>
                            </Form>
                        </CardBody>
                        <CardFooter>
                            {loadingsubmit ? (
                                    <>
                                        <Button className="my-4" color="success" type="button" onClick={handleSubmit}>
                                            {t("Send us your request")} 
                                        </Button>
                                    </>
                                ):(
                                    <>
                                        <Button color="success" disabled>
                                        <Spinner size="sm">
                                            {t("Submitting your request...")}
                                        </Spinner>
                                        <span>
                                            {' '}{t("Submitting your request...")}
                                        </span>
                                        </Button>
                                    </>
                            )}
                        </CardFooter>
                    </Card>
                    <Modal isOpen={modal} toggle={toggleModal}>
                        <ModalHeader toggle={toggleModal}>{t('Your request has been submitted')}</ModalHeader>
                        <ModalBody>
                            <p>{t('A email has been sent to your email.') }</p>
                            <p>{t('One operator will review your request, and send you a email as soon as possible.') }</p>
                        </ModalBody>
                    </Modal>
                </Col>
            </Row>
        </Container>
        </div>
    )
}

export default Support